import Axios from "axios";
import {
    SET_SALES_TIERED_COMMISSION_LIST,
    UNSET_SALES_TIERED_COMMISSION_LIST,
    SET_EDITING_SALES_TIERED_COMMISSION,
    UNSET_EDITING_SALES_TIERED_COMMISSION
} from "@/store/mutation-types";
import { saveUpdateTieredCommission, getSalesTieredCommissionList, getSalesTieredCommissionById } from "@/store/api";

const state = {
    getSalesTieredCommissionList: [],
    editingSalesTieredCommission: null,
};

const getters = {
    getSalesTieredCommissionList(state) {
        return state.getSalesTieredCommissionList;
    },
    getEditingSalesTieredCommission(state) {
        return state.editingSalesTieredCommission;
    }
};

const mutations = {
    [SET_SALES_TIERED_COMMISSION_LIST](state, data) {
        state.getSalesTieredCommissionList = data;
    },
    [UNSET_SALES_TIERED_COMMISSION_LIST](state) {
        state.getSalesTieredCommissionList = [];
    },
    [SET_EDITING_SALES_TIERED_COMMISSION](state, data) {
        state.editingSalesTieredCommission = data;
    },
    [UNSET_EDITING_SALES_TIERED_COMMISSION](state) {
        state.editingSalesTieredCommission = [];
    }
};

const actions = {
    saveUpdateTieredCommission({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateTieredCommission, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesTieredCommissionList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesTieredCommissionList, { params: data })
                .then(function (response) {
                    commit("SET_SALES_TIERED_COMMISSION_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_TIERED_COMMISSION_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    getSaleTieredCommissionById({ commit }, data) {
        const getSaleTieredCommission = `${getSalesTieredCommissionById}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleTieredCommission)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
